import React from 'react';

export interface EnvironmentConfig {
    api: {
        baseUrl: string;
    };
    cognito: {
        region: string;
        userPoolId: string;
        userPoolWebClientId: string;
    };
}

export const EnvironmentContext = React.createContext<EnvironmentConfig>(undefined!);